import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    scroll: {
      padding: 20,
    },
    section: {
      marginBottom: 25,
    },
    label: {
      fontSize: 16,
      fontWeight: '600',
      marginBottom: 4,
    },
    labelHint: {
      fontSize: 13,
      marginBottom: 12,
    },
    input: {
      borderWidth: 1,
      borderRadius: 10,
      padding: 15,
      fontSize: 16,
    },
    textArea: {
      height: 80,
      textAlignVertical: 'top',
    },
    saveBtn: {
      padding: 18,
      borderRadius: 10,
      alignItems: 'center',
      marginTop: 10,
    },
    saveBtnText: {
      fontSize: 16,
      fontWeight: 'bold',
    },
    cancelBtn: {
      padding: 18,
      alignItems: 'center',
      marginTop: 10,
    },
    cancelBtnText: {
      fontSize: 16,
    },
    limitOptions: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 10,
    },
    limitOption: {
      paddingHorizontal: 16,
      paddingVertical: 10,
      borderRadius: 20,
      borderWidth: 1,
      minWidth: 60,
      alignItems: 'center',
    },
    limitOptionText: {
      fontSize: 14,
      fontWeight: '600',
    },
  });
